import MGR from '../interceptors/MgrPublic';
import MGRAPI from '../interceptors/MgrApi';

export const getLegalTemplateByToken = (token) => MGR.get(`/auth/signup/${token}/legal`);

export const acceptLegalByToken = (token) => MGR.put(`/auth/signup/${token}/legal`);

export const getLegalTemplate = () => MGRAPI.get('/clients/legal');

export const acceptLegal = () => MGRAPI.put('/clients/legal');
